/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'coding': {
    width: 259.961,
    height: 200,
    viewBox: '0 0 1331 1024',
    data: '<defs/><path pid="0" d="M4.608 861.491c0-25.907 8.192-47.82 27.34-68.3L337.92 487.423 31.949 174.694a98.304 98.304 0 01-27.341-68.198c0-26.01 9.626-47.82 28.672-66.97 19.149-19.046 40.96-28.672 67.072-28.672 25.907 0 47.718 9.626 68.198 27.341l375.501 378.163c17.715 21.914 27.341 45.056 27.341 69.632 0 24.576-9.626 47.821-27.34 66.97L168.447 928.358a94.003 94.003 0 01-68.198 28.672 96.256 96.256 0 01-68.301-28.672 89.6 89.6 0 01-27.341-66.867zm533.914-68.3a101.376 101.376 0 0169.632-28.673l531.046 2.765a93.696 93.696 0 0194.208 95.54 93.696 93.696 0 01-27.238 68.3 97.28 97.28 0 01-66.97 28.672h-2.56L606.822 955.7a94.618 94.618 0 01-69.632-27.34 94.618 94.618 0 01-27.238-69.633 96.666 96.666 0 0128.672-65.536z"/>'
  }
})
